import { EXT_RESOURCE_NOT_READY_MESSAGE } from '@contracts/assistant-external';

/** The words of the external confirm card (AI S6 spec §7.7, §7.4, §7.5, §13; mockup section 3). */
export const EXT_CARD_LABELS = {
  /** §7.7: a tool the admin set to "Luôn xác nhận". */
  warnSend: (server: string) => `Gửi ra ${server}. Không hoàn tác được.`,
  /** §7.4 "Read bị nâng": the spec's sentence only — the mockup's second sentence is false for a `crossed` raise. */
  warnRaised: (server: string) => `Yêu cầu này gửi dữ liệu tới ${server}.`,
  empty: '(trống)',
  yes: 'Có',
  no: 'Không',
  /** §7.3: the confirm is out (in flight, or the server answered `sending`). */
  sending: (server: string) => `Đang gửi tới ${server}…`,
  sent: 'Đã gửi',
  failed: 'Không gửi được',
  /** §13 `EXT_UNKNOWN`: the request may have gone. */
  unknown: (server: string) => `Không chắc đã gửi — kiểm tra ở ${server}.`,
  left: (ms: number) => {
    const s = Math.max(0, Math.ceil(ms / 1000));
    return `còn ${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
  },
  expired: 'đã hết hạn',
  confirm: 'Xác nhận',
  edit: 'Sửa',
  reject: 'Từ chối',
  save: 'Lưu',
  cancel: 'Hủy',
  /** §7.5: the line under an internal card's header in a conversation that read outside content. */
  taint: (servers: readonly string[]) => `Hội thoại này có nội dung từ ${servers.join(', ')}`,
} as const;

/** §13, by code, `server` the card's server name. */
const EXT_ERROR: Record<string, (server: string) => string> = {
  EXT_TOOL_UNAVAILABLE: () => 'Tool này vừa bị tắt hoặc đổi, admin cần duyệt lại.',
  EXT_AUTH_EXPIRED: (n) => `Kết nối ${n} cần đăng nhập lại ở Cài đặt trợ lý › Kết nối.`,
  EXT_SENSITIVE_BLOCKED: (n) => `Hội thoại này đã xem dữ liệu không được gửi tới ${n}. Mở hội thoại mới.`,
  EXT_CALL_FAILED: (n) => `${n} không phản hồi.`,
  EXT_UNKNOWN: (n) => EXT_CARD_LABELS.unknown(n),
  EXT_TURN_LIMIT: () => 'Đã gọi hệ thống ngoài 10 lần trong lượt này.',
  EXT_ARGS_TOO_LARGE: () => 'Nội dung gửi đi quá lớn.',
  EXT_RESOURCE_NOT_READY: () => EXT_RESOURCE_NOT_READY_MESSAGE,
};

/** The §13 text of `code`; `fallback` (the server's own words) for a code §13 does not list. */
export const extErrorText = (code: string, server: string, fallback: string): string =>
  Object.hasOwn(EXT_ERROR, code) ? EXT_ERROR[code]!(server) : fallback;

/**
 * A confirm refusal that leaves the card pending, so it is said on the card (the §13 codes, read-only mode, args the
 * schema refuses). Any other (closed, expired, a running turn, offline) goes to the composer as for every card.
 */
export const onCardRefusal = (code: string): boolean =>
  code.startsWith('EXT_') || code === 'ASSISTANT_READ_ONLY' || code === 'VALIDATION';
